import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Upload, Button, Icon, message, Modal } from 'antd';


class UploadFile extends Component {
    constructor(props) {
        super(props)
    }

    fileBeforeUpload(file, curFileList) {
        const that = this;
        const { fileList, type, limit } = this.props;
        return new Promise((resolve, reject) => {
            if (limit) {
                let total = fileList.length + curFileList.length;
                if (total > limit) {
                    message.destroy();
                    // message.error('最多只能上传' + limit + '个文件', 2);
                    Modal.error({
                        content: '最多只能上传' + limit + '个文件',
                    });
                    reject('false')
                };
            }
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isLt2M) {
                // message.error('文件大小不能超过10MB!', 2);
                Modal.error({
                    content: '文件大小不能超过10MB',
                });
                reject('false')
            };
            resolve(file)
        });
    };

    fileUploadChange(info) {
        const that = this;
        const { setValue, type, feild, cb, limit } = this.props;
        let fileList = info.fileList;
        console.log(fileList)
        // 2. read from response and show file link
        fileList = fileList.map((file) => {
            if (file.response) {
                // Component will show file.url as link
                file.url = file.response.url;
            }
            return file;
        });
        // 3. filter successfully uploaded files according to response from server
        fileList = fileList.filter((file) => {
            if (file.response) {
                return file.response.statusCode === 1000;
            }
            return true;
        });
        setValue(feild, fileList);
        typeof cb === 'function' && cb(fileList)
    }

    render() {
        const { fileList, setValue, type, url } = this.props;
        return (
            <Upload
                name="uploadFile"
                listType={type === 0 ? "text" : "picture"}
                accept={type === 0 ? ".doc,.docx,.xlsx,.xls,.csv,.pdf" : "image/*"}
                className='upload-list-inline'
                action={url ? url : "/labpro/ajaxUpload/myUpload.do"}
                fileList={fileList}
                beforeUpload={(file, fileList) => this.fileBeforeUpload(file, fileList)}
                onChange={(info) => this.fileUploadChange(info)}
            >
                {type === 0 ?
                    <Button><Icon type="upload" /> 上传文件</Button>
                    :
                    <Button type="primary"><Icon type="upload" />添加图片</Button>
                }
            </Upload>
        )
    }
}

UploadFile.propTypes = {
    type: PropTypes.number.isRequired, //0为上传文件，1为上传图片
    setValue: PropTypes.func.isRequired,
    fileList: PropTypes.array.isRequired,
    limit: PropTypes.number
}

export default UploadFile
